<script lang="ts">
    import { inview } from "svelte-inview"
    import type { ObserverEventDetails, ScrollDirection, Options } from "svelte-inview"
    import { apiBaseOverride, location } from "../store"
    import blocks from "./blocks"
    import MedialibImage from "./MedialibImage.svelte"
    export let block: ContentBlockEntry
    export let allwaysInView: boolean = false

    export let apiBase: string = null
    if (apiBase) {
        $apiBaseOverride = apiBase
        // in admin, no in view handling
        allwaysInView = true
    }

    $: blockComponent = blocks[block.type] || blocks.default

    let isInView: boolean = allwaysInView
    let scrollDirection: ScrollDirection
    const inViewOptions: Options = {
        rootMargin: "-50px",
        unobserveOnEnter: true,
    }

    const handleInViewChange = ({ detail }: CustomEvent<ObserverEventDetails>) => {
        isInView = detail.inView || allwaysInView
        scrollDirection = detail.scrollDirection
    }

    let scrollTargetContainer: HTMLDivElement
    let lastAnchor: string
    $: if (block.anchorId && typeof window !== "undefined") {
        const targetAnchor = $location.hash
        if (targetAnchor !== lastAnchor && scrollTargetContainer) {
            lastAnchor = targetAnchor
            if (targetAnchor == "#" + block.anchorId) {
                setTimeout(() => {
                    scrollTargetContainer.scrollIntoView({ behavior: "instant", block: "start", inline: "nearest" })
                    setTimeout(() => {
                        scrollTargetContainer.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                    }, 600) // after in-view scroll animation
                }, 10)
            }
        }
    }
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !block.hide}
    {#if block.anchorId}
        <!-- position 100px above -->
        <div style="position:relative;">
            <div bind:this="{scrollTargetContainer}" style="position: absolute; top: -100px"></div>
        </div>
    {/if}
    <section
        data-type="{block.type}"
        use:inview="{inViewOptions}"
        on:inview_change="{handleInViewChange}"
        class:hidden="{!!block.hide}"
        class:in-view="{isInView}"
        class:not-in-view="{!isInView}"
        class:from-bottom="{isInView && scrollDirection?.vertical === 'down'}"
        class:from-top="{isInView && scrollDirection?.vertical === 'up'}"
        class="{block.overflow?.overflowShow ? 'overflow-show' : ''} {block.padding?.top
            ? 'tp-' + block.padding.top
            : ''} {block.padding?.bottom ? 'bp-' + block.padding.bottom : ''} {blockComponent.sectionClass} {block
            .background?.color
            ? block.background.color + '-bg'
            : ''} {block.type == 'contentCards' && block.contentCards?.type?.startsWith('image') ? 'solutions' : ''}"
    >
        {#if block.background?.image}
            <div class="background-image">
                <!-- Wenn Element Hintergrundbild hat, hier einfügen -->
                <figure>
                    <MedialibImage id="{block.background.image}" />
                </figure>
            </div>
        {/if}

        {#if block.headline || block.subline}
            <div class="container bp-xl">
                <!-- Überschrift Element -->
                {#if block.headline}
                    {#if block.headlineH1}
                        <h1 class="h2">{block.headline}</h1>
                    {:else}
                        <h2>{block.headline}</h2>
                    {/if}
                {/if}
                {#if block.subline}
                    <h3>{block.subline}</h3>
                {/if}
            </div>
        {/if}

        <svelte:component this="{blockComponent.component}" {block} {apiBase} />

        {#if block.callToAction?.buttonText}
            <div class="container tp-l">
                <!-- Falls es einen Button für "mehr" gibt, ausgeben -->
                <div class="button-wrap">
                    <a
                        href="{block.callToAction.buttonLink}"
                        class="cta btn-primary"
                        target="{block.callToAction.buttonTarget || undefined}">{block.callToAction.buttonText}</a
                    >
                </div>
            </div>
        {/if}
    </section>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }

    .in-view {
        transition:
            transform 0.5s,
            opacity 0.5s;
        opacity: 1;

        :global {
            .container .grid {
                div:first-of-type {
                    transition: transform 0.5s;
                    transform: unset;
                    &.icon {
                        transform: unset;
                    }
                }
                div:last-of-type {
                    transition: transform 0.5s;
                    transform: unset;
                }
            }
        }
    }

    .not-in-view {
        transition:
            transform 0.5s,
            opacity 0.5s;
        opacity: 0;
        :global {
            .container .grid {
                div:first-of-type {
                    transform: translateX(-200px);
                    &.icon {
                        transform: translateX(-200px);
                    }
                }
                div:last-of-type {
                    transform: translateX(200px);
                }
            }
        }
    }
</style>
